import { useAppDispatch, useAppSelector } from 'app/hooks';
import { KEY_LANGUAGE_LOCALSTORAGE } from 'consts/app';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageEnum, changeLanguage, selectCurrentLanguage } from 'redux/userSlice';
import { getLocalStorage, setLocalStorage } from 'utils/sessionStorage';

export const getLanguageKey = (value: string): LanguageEnum => {
  switch (value) {
    case 'zh':
      return LanguageEnum.CHINESE;
    case 'km':
      return LanguageEnum.CAMBODIA;
    case 'th':
      return LanguageEnum.THAI;
    case 'es':
      return LanguageEnum.SPANISH;
    case 'fr':
      return LanguageEnum.FRENCH;
    case 'tr':
      return LanguageEnum.TURKEY;
    case 'ru':
      return LanguageEnum.RUSSIA;
    default:
      return LanguageEnum.ENGLISH;
  }
};

const useMutiLanguage = () => {
  const language = useAppSelector(selectCurrentLanguage);
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    const key = getLocalStorage(KEY_LANGUAGE_LOCALSTORAGE);
    if (key) {
      dispatch(changeLanguage(getLanguageKey(key)));
    } else {
      setLocalStorage(KEY_LANGUAGE_LOCALSTORAGE, 'en');
    }
  }, []);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);
};

export default useMutiLanguage;
